export default {
	client: [
		{
			url: "/orders",
			name: "orders",
			slug: "orders",
			icon: "ClipboardIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
	],
	author: [
		{
			url: "/exchange",
			name: "exchangePageName",
			slug: "exchange",
			icon: "RepeatIcon",
			tag: "notification/get-works-notification-count"
		},
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
			tag: "notification/get-orders-notification-count"
		},
		{
			url: "/author-tasks",
			name: "AuthorTasks",
			slug: "author-tasks",
			icon: "CalendarIcon",
			tag: "notification/get-author-tasks-notification-count"
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "statistic",
			icon: "PieChartIcon",
		},
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
	],
	manager: [
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
			tag: "notification/get-orders-notification-count"
		},
		{
			url: "/tasks",
			name: "tasks",
			slug: "tasks",
			icon: "CalendarIcon",
			tag: "notification/get-tasks-notification-count"
		},
		{
			url: "/my-authors-tasks",
			name: "MyAuthorsTasks",
			slug: "my-authors-tasks",
			icon: "CalendarIcon",
			tag: "notification/get-my-authors-tasks-notification-count"
		},
		{
			url: "/clientsM",
			name: "clients",
			slug: "clients",
			icon: "UsersIcon",
			tag: "notification/get-clients-notification-count"
		},
		{
			url: "/manager/last-messanges",
			name: "lastMassages",
			slug: "lastMassages",
			icon: "MessageCircleIcon",
		},
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "stats",
			icon: "PieChartIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
	],
	admin: [
		{
			url: "/exchange",
			name: "exchangePageName",
			slug: "exchange",
			icon: "RepeatIcon",
		},
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
		},
		{
			url: "/tasks",
			name: "tasks",
			slug: "tasks",
			icon: "CalendarIcon",
			tag: "notification/get-tasks-notification-count"
		},
		{
			url: "/managers",
			name: "managers",
			slug: "managers",
			icon: "GridIcon",
		},
		{
			url: "/clients",
			name: "clients",
			slug: "clients",
			icon: "UsersIcon",
		},
		{
			url: "/authors",
			name: "authors",
			slug: "authors",
			icon: "Edit3Icon",
			tag: "notification/get-authors-notification-count"
		},
		{
			url: "/sites",
			name: "sites",
			slug: "sites",
			icon: "GlobeIcon",
		},
		{
			url: "/partners",
			name: "partners",
			slug: "partners",
			icon: "Share2Icon",
		},
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
			tag: "notification/get-payouts-notification-count"
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "stats",
			icon: "PieChartIcon",
		},
		{
			url: "/logs",
			name: "logInMenu",
			slug: "logs",
			icon: "ListIcon",
		},
		{
			url: "/typeWorks",
			name: "workTypes",
			slug: "typeWorks",
			icon: "BriefcaseIcon",
		},
		// {
		// 	url: "/templates",
		// 	name: "templateAnswers",
		// 	slug: "templates",
		// 	icon: "CheckIcon",
		// },
		{
			url: "/chat-templates",
			name: "chatTemplates",
			slug: "chat-templates",
			icon: "MessageSquareIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
			tag: "notification/get-support-notification-count"
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
	],
	partner: [
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
		},
		{
			url: "/clients",
			name: "clients",
			slug: "clients",
			icon: "UsersIcon",
		},
		{
			url: "/sites",
			name: "sites",
			slug: "sites",
			icon: "GlobeIcon",
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "stats",
			icon: "PieChartIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
	]


}
